import React from 'react';
import { Navigate} from 'react-router-dom';
import useService from 'hooks/useService'

const ProtectedRoute = ({ children, mode }) => {
    const { getURLData, getStorageData } = useService()
    const isOTPVerified = getStorageData('isOtpVerified') === 1

    // Extract shortid (first 2 parts of path)
    const pathList = window.location.pathname.split('/').filter(Boolean);
    const pathname = pathList[pathList.length - 1]


    return isOTPVerified === 1 && pathname !== 'unlockdoor'
            ? <Navigate to={`/${getURLData().defaultURL}/unlockdoor`} replace />
            : isOTPVerified === 0 && pathname !== 'verifyotp'
                ? <Navigate to={`/${getURLData().defaultURL}/verifyotp`} replace />
                : children;
};

export default ProtectedRoute;

// Case 1: Verify Page Protection
// if (mode === "verifyotp") {
//     if (isOTPVerified === 1) {
//         return <Navigate to={`/${getURLData().defaultURL}/unlockdoor`} replace />;
//     }
//     return children;
// }

// // Case 2: Unlock Door Protection
// if (mode === "unlockdoor") {
//     if (!isOTPVerified) {
//         return <Navigate to={`/${getURLData().defaultURL}/verifyotp`} replace />;
//     }
//     return children;
// }